module.exports = __webpack_public_path__ + "assets/icons/ic_close-6afa.svg";